import appendVideo from "./appendVideo";
import {
    loadSpiner,
    lightboxActions,
    lightboxClean,
    subscribeButton,
    carouselCheck,
    mobileElementsAlign,
    disableEdgeButtonsObserverSetup,
} from "./smallScripts";
import handleSearchOverlayToggle from "../../component-search/js/global";
import runCustomSelect from "../js/custom-select";
import carousel from "../../carousel/js/global";
import onestoryCarousel from "../../carousel_one-story/js/global";
import responsiveNav from "../js/navigation";
import debounce from "lodash/debounce";
import {
    fbjsFacetSwitcher,
    fbjsFacetSwitcherUnticker,
} from "../js/fbjsFacetSwitcher";
import { fbjsDateNarrowing } from "../js/fbjsDateNarrowing";
import getStickyFromTop from "./sticky";
import expertiseOpen from "../../tags/js/global";
import progressBar from "../../progress-bar/js/global";
import displayDropdown from "../../redesign-submenu/js/global";
import {
    googleTranslateElementInit2,
    changeOpenerLang,
    checkSelectOption,
} from "../../auto-translate/js/global.js";
import {
    handleEndMarketDropdown,
    handleGeographyDropdown,
} from "../../filters-redesign/js/global.js";
import handleFilersButtons from "../../filters/js/global.js";
import navigationRedesign from "./navigation-redesign.js";

// Global variables
let squiz = {
    fn: {
        appendVideo,
        loadSpiner,
        lightboxActions,
        lightboxClean,
        runCustomSelect,
        subscribeButton,
        carouselCheck,
    },
    vars: {
        desktopWidth: 1025,
        desktopWidthMid: 1231,
    },
};

window.squiz = squiz;
let windowWidth;

/**
 * @description - Init functions when DOM is ready
 */
document.addEventListener("DOMContentLoaded", function () {
    windowWidth = window.innerWidth;

    handleSearchOverlayToggle();
    runCustomSelect();
    responsiveNav();
    fbjsFacetSwitcher();
    fbjsFacetSwitcherUnticker();
    fbjsDateNarrowing();
    squiz.fn.subscribeButton();
    navigationRedesign();
});
window.addEventListener("load", function () {
    carousel();
    onestoryCarousel();
    getStickyFromTop();
    expertiseOpen();
    mobileElementsAlign();
    googleTranslateElementInit2();
    changeOpenerLang();
    checkSelectOption();
    progressBar();
    displayDropdown();
    disableEdgeButtonsObserverSetup();
    handleEndMarketDropdown();
    handleGeographyDropdown();
    handleFilersButtons();
});

/**
 * @description - Global onresize
 */
window.onresize = debounce(function () {
    if (window.innerWidth != windowWidth) {
        // Update the window width for next time
        windowWidth = window.innerWidth;

        responsiveNav();
        carouselCheck();
    }
}, 30);

const customCheckboxHandler = () => {
    const customCheckbox =
        document.querySelectorAll(".custom-checkbox-input") ?? null;
    customCheckbox &&
        customCheckbox.forEach((item) => {
            item.addEventListener("click", (e) => {
                e.currentTarget.classList.toggle("input-checked");
            });
        });
};
customCheckboxHandler();
